// View counts for Open Lab, lecture blogs, and solution pages (public, increment-only).
// Loaded only on those surfaces. API URL is set by snippets/article-views-boot.liquid.
(function () {
  var API = window.MA_VIEWS_API;
  if (!API) return;

  // Our own visits should not sit in the numbers we read to judge the site.
  // `?noview=1` marks this browser, `?noview=0` clears it, and the mark lives
  // in localStorage so it survives closing the tab. Reads keep running: the
  // counter on the page still shows the real number, this only stops the +1.
  var OPTOUT_KEY = 'ma_views_optout';

  function optedOut() {
    try {
      var flag = (location.search.match(/[?&]noview=([01])/) || [])[1];
      if (flag === '1') localStorage.setItem(OPTOUT_KEY, '1');
      else if (flag === '0') localStorage.removeItem(OPTOUT_KEY);
      var off = localStorage.getItem(OPTOUT_KEY) === '1';
      if (flag) console.log('[ma-views] this browser is ' + (off ? 'EXCLUDED from' : 'counted in') + ' view counts');
      return off;
    } catch (e) {
      return false;
    }
  }

  function idsFrom(nodes) {
    var ids = [];
    var seen = {};
    nodes.forEach(function (el) {
      var id = el.getAttribute('data-ma-views');
      if (id && !seen[id]) {
        seen[id] = true;
        ids.push(id);
      }
    });
    return ids;
  }

  function paint(views) {
    document.querySelectorAll('[data-ma-views]').forEach(function (el) {
      var id = el.getAttribute('data-ma-views');
      if (!views.hasOwnProperty(id)) return;
      var n = views[id];
      var num = el.querySelector('.ma-views__n');
      var lab = el.querySelector('.ma-views__l');
      if (num) num.textContent = Number(n).toLocaleString();
      if (lab) lab.textContent = n === 1 ? 'view' : 'views';
      el.removeAttribute('hidden');
      el.classList.add('is-ready');
    });
  }

  function get(ids) {
    return fetch(API + '?ids=' + encodeURIComponent(ids.join(',')), {
      method: 'GET',
      credentials: 'omit',
    }).then(function (r) {
      if (!r.ok) throw new Error('get ' + r.status);
      return r.json();
    }).then(function (data) {
      paint(data.views || {});
    });
  }

  function post(id) {
    return fetch(API, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id }),
    }).then(function (r) {
      if (!r.ok) throw new Error('post ' + r.status);
      return r.json();
    }).then(function (data) {
      paint(data.views || {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var nodes = document.querySelectorAll('[data-ma-views]');
    if (!nodes.length) return;
    var countEl = document.querySelector('[data-ma-views-count]');
    var design = window.Shopify && Shopify.designMode;
    var skip = optedOut();
    var ids = idsFrom(Array.prototype.slice.call(nodes));
    if (!ids.length) return;

    if (countEl && !design && !skip) {
      var id = countEl.getAttribute('data-ma-views');
      var key = 'ma_views_hit_' + id;
      var already = false;
      try { already = sessionStorage.getItem(key) === '1'; } catch (e) {}
      var req = already ? get([id]) : post(id);
      req.then(function () {
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      }).catch(function () {});
      var rest = ids.filter(function (x) { return x !== id; });
      if (rest.length) get(rest).catch(function () {});
      return;
    }
    get(ids).catch(function () {});
  });
})();
